<template>
  <div :class="cardObjectsClass">
    <div :class="containerClass">
      <div :class="titleClass" v-text="title" />
      <div ref="mapCard" :id="isPrint ? `map-card-${leadId}` : 'map-card'" :class="printMap" />
      <div v-if="leads.length > 1 && !isMobile && !isPrint" class="printLink" v-text="'Версия для печати'" @click="openPrint" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ymaps from 'ymaps'
import { mapGetters } from 'vuex'
import Common from '@/services/common'

export default {
  name: 'ObjectMap',
  props: {
    leadId: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters(['leads', 'config', 'fieldsConfig', 'isPrint', 'printLink']),
    title() {
      return this.leads.length === 1 || this.isPrint ? 'Объект на карте' : 'Объекты на карте' 
    },
    titleClass() {
      return {
        'title-section': !this.isPrint,
        'title-map-print': this.isPrint,
      }
    },
    cardObjectsClass() {
      return {
        'card-objects': !this.isPrint,
        'ml-10px': this.isPrint,
      }
    },
    containerClass() {
      return {
        container: !this.isPrint,
      }
    },
    mapObjects() {
      return this.leads
        .map((l, lIdx) => {
          if (this.isPrint && l.id !== this.leadId) return
          const cfs = l.custom_fields_values || []

          const address = this.prepareValue(cfs, this.config.address)
          const latitude = this.prepareValue(cfs, this.config.latitude)
          const longitude = this.prepareValue(cfs, this.config.longitude)

          return latitude && longitude && { coordinates: [latitude, longitude], address, idx: lIdx + 1 }
        })
        .filter(Boolean)
    },
    host() {
      return document.location.origin
    },
    printMap() {
      return {
        printMap: this.isPrint,
      }
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
  },
  methods: {
    openPrint() {
      window.open(this.printLink)
    },
    initMap(ymaps) {
      const map = this.$refs.mapCard
      const mapId = map.getAttribute('id')

      const initialCenter = this.mapObjects?.length
        ? this.mapObjects.find(o => o.coordinates?.length)?.coordinates
        : [44.572312, 33.536702]
      const mapInstance = new ymaps.Map(
        mapId,
        { center: initialCenter, zoom: this.isPrint ? 10 : 14, controls: [] },
        { searchControlProvider: "yandex#search" }
      )

      this.mapObjects
        .map(o => this.getPlacemark(ymaps, o, 'pin'))
        .forEach(p => mapInstance.geoObjects.add(p))
      
      // this.setCenter(ymaps, mapInstance)
      if (!this.isPrint) {
        Object
          .keys(this.objectTypes)
          .forEach(objectType => this.setControlByName(ymaps, mapInstance, objectType))
      }

      if (this.isMobile) {
        mapInstance.behaviors.disable('scrollZoom')
        mapInstance.behaviors.disable('drag')
        map.addEventListener('touchstart', () => {
          mapInstance.behaviors.enable('scrollZoom')
          mapInstance.behaviors.enable('drag')
        })
      }

      mapInstance.controls.remove('searchControl')

      this.addZoomControl(ymaps, mapInstance)
    },
    getPlacemark(ymaps, { coordinates, address, idx }, type) {
      return new ymaps.Placemark(
        coordinates,
        { 
          balloonContent: address && `<p class="text-map">${address}</p>`,
          iconContent: (type === 'pin' && !this.isPrint) ? `<strong>${idx}</strong>` : '',
        },
        {
          iconLayout: 'default#imageWithContent',
          iconImageHref: `${this.host}/rc/img/${type}.svg`,
          hideIconOnBalloonOpen: false,
          iconImageSize: [38, 51],
          iconContentOffset: type === 'pin' && idx < 10 ? [14, 13] : [11, 13],
          balloonOffset: [7, -38],
        }
      )
    },
    setCenter(ymaps, mapInstance) {
      const { container, geoObjects: objects } = mapInstance

      const objectsCenter = ymaps.util.bounds
        .getCenterAndZoom(objects.getBounds(), container.getSize())
        .center
      mapInstance.setCenter(objectsCenter, 13)

      return objectsCenter
    },
    prepareValue(cfs, fieldId) {
      return Common.prepareField({ cfs, fieldId, fieldsConfig: this.fieldsConfig }).value
    },
    addZoomControl(ymaps, mapInstance) {        
      const ZoomLayout = ymaps.templateLayoutFactory.createClass(`<div>
        <div id='zoom-in' class='zoom-btn'><i class='icon-plus'></i></div>
        <div id='zoom-out' class='zoom-btn'><i class='icon-minus'></i></div>
      </div>`, {
        build: function () {
            ZoomLayout.superclass.build.call(this)

            this.zoomInCallback = ymaps.util.bind(this.zoomIn, this)
            this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this)

            document.querySelector('#zoom-in').addEventListener('click', this.zoomInCallback)
            document.querySelector('#zoom-out').addEventListener('click', this.zoomOutCallback)
        },
        clear: function () {
            document.querySelector('#zoom-in').removeEventListener('click', this.zoomInCallback)
            document.querySelector('#zoom-out').removeEventListener('click', this.zoomOutCallback)

            ZoomLayout.superclass.clear.call(this)
        },
        zoomIn: () => mapInstance.setZoom(mapInstance.getZoom() + 1, { checkZoomRange: true }),
        zoomOut: () => mapInstance.setZoom(mapInstance.getZoom() - 1, { checkZoomRange: true }),
      })
      const zoomControl = new ymaps.control.ZoomControl({ options: {
        layout: ZoomLayout,
        position: {
          bottom: 'auto',
          left: 'auto',
          right: 10,
          top: 108,
        },
      }})

      // mapInstance.behaviors.disable('scrollZoom')
      mapInstance.controls.add(zoomControl)
    },
    setControlByName(ymaps, mapInstance, name) {
      const objectControl = this.objectTypes[name].control

      const mapControl = new ymaps.control.Button({
        data: objectControl.data,
        options: {
          layout: ymaps.templateLayoutFactory.createClass(
            `<button class='${this.isMobile ? 'map-btn-m' : 'map-btn'} {% if state.selected %}map-btn--selected{% endif %}' title='{{ data.title }}'>
              ${objectControl.svg}
              {{ data.content }}
            </button>`
          ),
          maxWidth: [178, 178, 178],
        }
      })

      mapControl.events.add(['select', 'deselect'], async ({ originalEvent }) => {
        const eventType = originalEvent.type
        const objects = this.objectTypes[name].objects

        if (eventType === 'deselect') {
          objects.forEach(p => mapInstance.geoObjects.remove(p))
          return
        }

        if (eventType === 'select') {
          if (objects.length) {
            objects.forEach(p => {
              mapInstance.geoObjects.add(p)
            })
            return
          }

          let allFeatures = []
          for (const o of this.mapObjects) {
            const coordinates = JSON.parse(JSON.stringify(o.coordinates)).reverse().join(',')
            let { features } = await this.searchObjects(name, coordinates)
            features = features.filter(f => !allFeatures.find(eF => JSON.stringify(eF.geometry.coordinates) === JSON.stringify(f.geometry.coordinates)))
            allFeatures = [...this.objectTypes[name].objects, ...features]
          }

          allFeatures
            .map(f => this.getPlacemark(ymaps, {
              coordinates: f.geometry.coordinates.reverse(),
              address: f.properties.description,
            }, name))
            .forEach(p => {
              this.objectTypes[name].objects.push(p)
              mapInstance.geoObjects.add(p)
            })
        }
      })

      mapInstance.controls.add(mapControl, {})
    },

    async searchObjects(text, coordsString) {
      return axios
        .get('https://search-maps.yandex.ru/v1/', {
          params: {
            text,
            type: 'biz',
            spn: '0.001,0.001',
            lang: 'ru_RU',
            rspn: 0,
            results: 6,
            ll: coordsString,
            apikey: this.apiKey,
          },
        })
        .then(res => res.data)
        .catch((e) => {
          console.error(e)
          return { features: [] }
        })
    },
  },
  setup() {
    return {
      apiKey: '2c893ece-d5f8-4076-a971-9ed964080f7c',
      objectTypes: {
        grocery: {
          name: 'grocery',
          objects: [],
          control: {
            data: {
              content: 'Прод. магазины',
            },
            svg: '<svg data-name="GroceryStoreIcon" class="map-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12"><path fill="currentColor" d="M11.278 2.25c.602 0 .827.6.677.975l-1.504 4.5a.722.722 0 0 1-.677.525H3.76c-.376 0-.676-.225-.751-.6L1.654 1.5H0V0h2.256c.376 0 .676.225.752.6l.375 1.65h7.895zM3.76 12c-.83 0-1.503-.672-1.503-1.5S2.929 9 3.759 9c.83 0 1.504.672 1.504 1.5S4.59 12 3.76 12zm6.015 0c-.83 0-1.503-.672-1.503-1.5S8.944 9 9.774 9c.83 0 1.504.672 1.504 1.5S10.605 12 9.774 12z"></path></svg>',
          },
        },
        clinic: {
          name: 'clinic',
          objects: [],
          control: {
            data: {
              content: 'Поликлиники',
            },
            svg: '<svg data-name="PolyclinicsIcon" class="map-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12"><path fill="currentColor" d="M11.25 3.75h-3v-3C8.25.3 7.95 0 7.5 0h-3c-.45 0-.75.3-.75.75v3h-3c-.45 0-.75.3-.75.75v3c0 .45.3.75.75.75h3v3c0 .45.3.75.75.75h3c.45 0 .75-.3.75-.75v-3h3c.45 0 .75-.3.75-.75v-3c0-.45-.3-.75-.75-.75z"></path></svg>',
          },
        },
        kindergartens: {
          name: 'kindergartens',
          objects: [],
          control: {
            data: {
              content: 'Детские сады',
            },
            svg: '<svg data-name="KindergardenIcon" class="map-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" width="14" height="16"><path fill="currentColor" d="M12.54 7.097c.803 0 1.46.592 1.46 1.315s-.657 1.315-1.478 1.315h-2.409c.019.098.019.18.019.28v1.347c0 .148-.019.312-.037.477l2.573 1.512c.602.608.602 1.512 0 2.12-.658.657-1.79.723-2.52.131l-1.222-1.1a4.471 4.471 0 0 1-4.034 0l-1.223 1.1c-.657.526-1.661.526-2.337 0C.602 15.02.53 14 1.168 13.343l2.591-1.545a3.917 3.917 0 0 1-.037-.477V9.973c0-.098.019-.197.019-.28H1.46C.656 9.694 0 9.104 0 8.38c0-.723.657-1.315 1.46-1.315h2.154c.128 0 .237.017.365.05-.913-.757-1.442-1.809-1.442-2.926 0-.197.018-.411.055-.608a2.087 2.087 0 0 1-.894-.576c-.712-.788-.566-1.955.31-2.596.876-.641 2.172-.51 2.884.279a4.769 4.769 0 0 1 4.07 0c.237-.263.548-.46.895-.575 1.077-.345 2.245.148 2.646 1.117.384.97-.164 2.038-1.223 2.384.238 1.347-.31 2.712-1.46 3.599a1.42 1.42 0 0 1 .584-.115h2.136zM9.71 1.081l.147.165c.328.246.602.542.821.87l.456.478a.936.936 0 0 0 .128-1.398c-.383-.41-1.077-.46-1.551-.115zM5.97 5.815c-.11-.099-.274-.099-.365 0-.092.099-.092.247.018.329.73.657 1.916.657 2.647 0 .11-.099.11-.23 0-.329a.262.262 0 0 0-.365 0c-.201.164-.439.28-.712.329V5.19c.474-.312.456-.69.456-.69 0-.197-.164-.345-.383-.361h-.657a.37.37 0 0 0-.384.361c.019.28.183.542.457.69v.954a1.542 1.542 0 0 1-.712-.329zM2.738 2.61l.438-.477c.237-.328.511-.624.821-.87l.165-.165c-.457-.362-1.15-.296-1.552.115a.911.911 0 0 0 .128 1.397zM4.813 4c.241 0 .437-.18.437-.4 0-.22-.196-.4-.438-.4-.241 0-.437.18-.437.4 0 .22.196.4.438.4zm4.375 0c.241 0 .437-.18.437-.4 0-.22-.196-.4-.438-.4-.241 0-.437.18-.437.4 0 .22.196.4.438.4z"></path></svg>',
          },
        },
        school: {
          name: 'school',
          objects: [],
          control: {
            data: {
              content: 'Школы',
              title: 'Ближайшие Школы'
            },
            svg: '<svg data-name="SchoolIcon" class="map-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12"><path fill="currentColor" d="M5.25 1.917V12L.45 9.861C.15 9.785 0 9.48 0 9.174V.77C0 .54.15.312.3.16c.225-.153.525-.23.75-.077l4.2 1.834zM11.7.16c.15.152.3.382.3.61v8.48c0 .306-.15.535-.45.687L6.75 12V1.917L11.025.083c.225-.076.45-.076.675.077z"></path></svg>',
          },
        },
      },
    }
  },
  mounted() {
    ymaps
      .load(`https://api-maps.yandex.ru/2.1/?lang=ru_RU`)
      .then(this.initMap)
  },
}
</script>

<style scoped>
.printMap {
  width: 300px !important;
  height: 21vh !important;
  margin-top: 10px;
  border-radius: 20px;
}

.title-map-print {
  line-height: 1.3em;
  font-size: 1.3em;
	font-family: 'Intro';
	text-align: left;
  font-weight: 700;
}
.ml-10px {
  margin-left: 10px;
}

.printLink {
  border-color: #e0e0e0;
  background-color: #17af4f;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  color: white;
  margin-top: 10px;
  cursor: pointer;
  width: 200px;
  text-align: center;
}

.map-print {
  width: 400px;
}

</style>

<style>
.map-btn-m,
.map-btn {
  background: #fff;
  color: #2f3130;
  height: 28px;
  border-radius: 14px;
  padding: 0 16px;
  font-size: 14px;
  border: none;
  outline: none;
  cursor: pointer;
  font-weight: 700;
  -webkit-box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  align-items: center;
}
.map-btn:hover,
.map-btn--selected {
  background: #1b9958;
  color: #fff;
}
.map-svg-icon {
  margin-right: 8px;
  width: 12px;
  height: auto;
}

.closestItem {
  display: flex;
  align-items: center;
}

.closestItem img {
  flex: 0 0 26px;
  margin-right: 5px;
}

.zoom-btn {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  opacity: .95;
  -webkit-box-shadow: 0 4px 10px 0 rgb(0 0 0 / 20%);
  box-shadow: 0 4px 10px 0 rgb(0 0 0 / 20%);
  margin-top: 16px;
  background-color: #fff;
}
.zoom-btn i {
  display: block;
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: 50%;
}
.icon-plus {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PHBhdGggZmlsbD0iIzI2MjYyNiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy45OTYgNy45OTZIMS45NDJjLS41NjEgMC0xLjAxLjQ1MS0xLjAxIDEuMDA5IDAgLjU2LjQ1MiAxLjAwOSAxLjAxIDEuMDA5aDYuMDU0djYuMDUzYzAgLjU2Mi40NTEgMS4wMSAxLjAwOSAxLjAxLjU2IDAgMS4wMDktLjQ1MiAxLjAwOS0xLjAxdi02LjA1M2g2LjA1M2MuNTYyIDAgMS4wMS0uNDUyIDEuMDEtMS4wMSAwLS41Ni0uNDUyLTEuMDA4LTEuMDEtMS4wMDhoLTYuMDUzVjEuOTQyYTEuMDA4IDEuMDA4IDAgMTAtMi4wMTggMHY2LjA1NHoiLz48L3N2Zz4=');
}
.icon-minus {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSI0Ij48cGF0aCBmaWxsPSIjMjYyNjI2IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjkzNiAzLjAxYTEuMDA4IDEuMDA4IDAgMTEwLTIuMDE4aDE0LjEyOGExLjAwOCAxLjAwOCAwIDExMCAyLjAxOEgxLjkzNnoiLz48L3N2Zz4=');
}
</style>